module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Circulars","desc":"This page contains the official Circulars for Dubai Financial Market. For the latest circulars, please refer to the below:"},"ar":{"title":"التعاميم","desc":"هذه الصفحة تضم التعاميم الرسمية الخاصة بسوق دبي المالي. للاطّلاع على أحدث هذه التعاميم، يرجى الرجوع إلى التالي"}}')
  delete Component.options._Ctor
}
